import { c as _c } from "react/compiler-runtime";
import { SVGProps } from "react";
export const Arrowright = properties => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.333 17.333a1.333 1.333 0 0 1 0-2.666h19.448L17.724 7.61a1.332 1.332 0 1 1 1.885-1.885l9.333 9.333a1.332 1.332 0 0 1 0 1.885l-9.333 9.333a1.332 1.332 0 1 1-1.885-1.885l7.057-7.057H5.333z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== properties) {
    t1 = <svg height="1em" viewBox="0 0 32 32" width="1em" xmlns="http://www.w3.org/2000/svg" {...properties}>{t0}</svg>;
    $[1] = properties;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};